/**
 * ConfigAlertaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ConfigAlerta} from '@/model/resource/ConfigAlerta'

/* TODO: review generated class */
@HttpExclude()
export class ConfigAlertaCollection extends PageCollection<ConfigAlerta> {
  constructor() {
    super(ConfigAlerta)
  }

  queryAsPage() {
    return this.listConfigAlerta()
  }

  async listConfigAlerta() {
    return await Request.get(`/admin/config-alerta`, {params: this.params})
      .name('listConfigAlerta')
      .as(this)
      .getResponse()
  }

  async listCsvConfigAlerta() {
    return await Request.get(`/admin/config-alerta/csv`, {params: this.params})
      .name('listCsvConfigAlerta')
      .as(this)
      .getResponse()
  }
}
